(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("thunderbolt-becky", [], factory);
	else if(typeof exports === 'object')
		exports["thunderbolt-becky"] = factory();
	else
		root["thunderbolt-becky"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 